import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Clickable } from 'reakit/Clickable';

import './style.css';

const CardRow = ({ className, status, children, onClick, looks }) => {
  const customClassName = classNames(
    'card-row',
    className,
    `-${status}`,
    `-${looks}`
  );
  return (
    <Clickable className={customClassName} onClick={onClick}>
      {children}
    </Clickable>
  );
};

CardRow.propTypes = {
  status: PropTypes.oneOf(['warning', 'success', 'info', 'danger']),
  looks: PropTypes.oneOf(['normal', 'admin']),
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

CardRow.defaultProps = {
  status: 'info',
  looks: 'normal',
  className: null,
  children: null,
  onClick: () => {},
};

export default CardRow;
